"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Convict = void 0;
const convict_1 = require("./convict");
Object.defineProperty(exports, "Convict", { enumerable: true, get: function () { return convict_1.Convict; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29uZmlnL2NvbnZpY3QvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsdUNBQW9DO0FBRTNCLHdGQUZBLGlCQUFPLE9BRUEifQ==